module.exports = __webpack_public_path__ + "img/DSC02567.3d3e8110.jpg";